import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new URLSearchParams();
      formData.append('email', email);

      const response = await fetch('https://readdy.ai/api/form/d57j5efahj0hkf71hv8g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formData.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/bfb5dc40c6a093a9dd4f6b333fdfa666.jpg"
          alt="Newsletter Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-900/85 via-emerald-800/80 to-emerald-900/85"></div>
      </div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Don't Miss Out on the Best Offers
        </h2>
        <p className="text-xl text-white/90 mb-10">
          Subscribe to our newsletter and get exclusive deals, health tips, and product updates
        </p>
        
        <form 
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto"
          data-readdy-form
          id="newsletter-form"
        >
          <input 
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            className="flex-1 px-6 py-4 rounded-full text-gray-900 text-lg focus:outline-none focus:ring-4 focus:ring-emerald-300"
            required
          />
          <button 
            type="submit"
            disabled={isSubmitting}
            className="bg-white text-emerald-700 px-10 py-4 rounded-full text-lg font-semibold hover:bg-emerald-50 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap disabled:opacity-50"
          >
            {isSubmitting ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>

        {submitStatus === 'success' && (
          <div className="mt-6 bg-white/20 backdrop-blur-sm text-white px-6 py-3 rounded-lg inline-block">
            <i className="ri-check-line mr-2"></i>
            Thank you for subscribing!
          </div>
        )}
        {submitStatus === 'error' && (
          <div className="mt-6 bg-red-500/20 backdrop-blur-sm text-white px-6 py-3 rounded-lg inline-block">
            <i className="ri-error-warning-line mr-2"></i>
            Something went wrong. Please try again.
          </div>
        )}
      </div>
    </section>
  );
}
